import TalentStatusIcon, {
  StatusTextStyle,
} from "../../../../../common/components/functional/talentStatus/TalentStatusIcon";
import { ReactComponent as ClipboardIcon } from "../../../../../common/icons/clipboardFilled.svg";
import {
  RejectionMessagePreview,
  RejectionMessagePreviewData,
} from "../../../../../common/components/functional/rejectionMessagePreview/RejectionMessagePreview";
import {
  CandidateStatusDetails,
  candidateRejectedMessageQuery,
} from "../../../TalentsStatusAPI";
import { TalentPreviewPopper } from "../../../../talents/TalentPreviewPopper";
import { TalentStatus } from "../../../../talents/types/common";
import { TalentLink } from "./TalentLink";

export const TalentNameWithPreview = ({
  bundleId,
  talentId,
  fullName,
  status,
  statusChanged,
  hasCoverLetter,
  rejectionMessageSent,
  statusTextStyle,
  disableLink = false,
}: {
  bundleId?: string;
  talentId: string;
  fullName: string;
  status?: TalentStatus;
  statusChanged?: string;
  hasCoverLetter?: boolean;
  rejectionMessageSent?: CandidateStatusDetails;
  statusTextStyle?: StatusTextStyle;
  disableLink?: boolean;
}) => {
  return (
    <>
      {disableLink ? fullName : <TalentLink id={talentId} name={fullName} />}
      <TalentStatusIcon
        status={status}
        statusChanged={statusChanged}
        statusTextStyle={statusTextStyle}
      />
      {hasCoverLetter && (
        <ClipboardIcon
          style={{ height: "17px", width: "17px", marginLeft: "2px" }}
        />
      )}
      <TalentPreviewPopper talentId={talentId} />
      <RejectionMessagePreview
        enabled={!!rejectionMessageSent && !!bundleId}
        cacheKey={`${bundleId ?? ""}-${talentId}-${rejectionMessageSent?.at ?? ""}`}
        fetchMessageDetails={async (): Promise<RejectionMessagePreviewData> => {
          if (!bundleId) {
            return {};
          }
          return await candidateRejectedMessageQuery(bundleId, talentId, {
            requestId: "none",
          });
        }}
      />
    </>
  );
};
